import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPageCross: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPageCross"><Path d="M4 22V2H20V12.7573L18.5 14.2573L16.3787 12.136L12.136 16.3786L14.2574 18.4999L12.136 20.6213L13.5148 22H4Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M22.1566 16.5L20.0353 18.6213L22.1566 20.7427L20.7424 22.1569L18.6211 20.0356L16.4998 22.1569L15.0856 20.7427L17.2069 18.6213L15.0856 16.5L16.4998 15.0858L18.6211 17.2071L20.7424 15.0858L22.1566 16.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPageCross;
